var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimelapse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8566 6.64337C11.9303 5.71712 10.7191 5.25004 9.49992 5.25004V10L6.14325 13.3567C7.99575 15.2092 11.0041 15.2092 12.8645 13.3567C14.717 11.5042 14.717 8.49587 12.8566 6.64337ZM9.49992 2.08337C5.12992 2.08337 1.58325 5.63004 1.58325 10C1.58325 14.37 5.12992 17.9167 9.49992 17.9167C13.8699 17.9167 17.4166 14.37 17.4166 10C17.4166 5.63004 13.8699 2.08337 9.49992 2.08337ZM9.49992 16.3334C6.00075 16.3334 3.16659 13.4992 3.16659 10C3.16659 6.50087 6.00075 3.66671 9.49992 3.66671C12.9991 3.66671 15.8333 6.50087 15.8333 10C15.8333 13.4992 12.9991 16.3334 9.49992 16.3334Z",
    fill: "#CBCDD8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelapse);
export default __webpack_public_path__ + "static/media/timelapse.325f347cb54cf384beab5309c0bfa80e.svg";
export { ForwardRef as ReactComponent };